import { h1Css, h2Css, h3Css, h4Css, h5Css, h6Css } from '@/styles/typography';
import styled from 'styled-components';

type StyleProps = {
  $type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  $color?: string;
  $styledAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  $mobileStyledAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const getHeadingCss = (style: string) => {
  switch (style) {
    case 'h1':
      return h1Css;
    case 'h2':
      return h2Css;
    case 'h3':
      return h3Css;
    case 'h4':
      return h4Css;
    case 'h5':
      return h5Css;
    case 'h6':
      return h6Css;
    default:
      return '';
  }
};

const BoldSpan = styled.span<StyleProps>`
  ${({ $styledAs, $type }) => getHeadingCss($styledAs || $type)}

  font-weight: 400;
  color: ${({ $color, theme }) => theme.colors[$color || 'black']};
`;

const RegularSpan = styled.span<StyleProps>`
  ${({ $styledAs, $type }) => getHeadingCss($styledAs || $type)}

  color: ${({ $color, theme }) => theme.colors[$color || 'black']};

  ${({ $mobileStyledAs, theme }) =>
    $mobileStyledAs &&
    `
    @media (max-width: ${theme.breakpoints.m}) {
      ${getHeadingCss($mobileStyledAs)}
    }
  `}
`;

const S = {
  BoldSpan,
  RegularSpan,
};

export default S;
